import { render, staticRenderFns } from "./PageClientsView.vue?vue&type=template&id=a7299470&scoped=true"
import script from "./PageClientsView.vue?vue&type=script&lang=js"
export * from "./PageClientsView.vue?vue&type=script&lang=js"
import style0 from "./PageClientsView.vue?vue&type=style&index=0&id=a7299470&prod&scoped=true&lang=css"
import style1 from "./PageClientsView.vue?vue&type=style&index=1&id=a7299470&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7299470",
  null
  
)

export default component.exports